import { render, staticRenderFns } from "./Pokemon.vue?vue&type=template&id=f774da1a&"
import script from "./Pokemon.vue?vue&type=script&lang=js&"
export * from "./Pokemon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports